(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('diary', {
        templateUrl: 'views/components/views/diary/diary.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$q', 'stateService', 'utilityService', 'diaryService', 'responsive', 'watcherFactory', 'graphAuthService', 'graphCalendarService', 'graphUserService', 'rememberService', function ($q, stateService, utilityService, diaryService, responsive, watcherFactory, graphAuthService, graphCalendarService, graphUserService, rememberService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            var watcher = watcherFactory.$create(vm);
            
            let timerTask = null;
            let timerOwner = null;

            let variableNames = {
                portal_user_keyno: ''
            };

            vm.model = {
                setting: {},
                selectListPortalUsers: [],
                taskList: {
                    records: []
                },
                ownerList: {
                    records: []
                }
            };

            vm.schedulerCallback = {
                onRemove: function (item) {
                    // BJS 20230905
                    diaryService.deleteCustact(item.id);

                    if (item.microsoft_graph_event_id.length > 0) {
                        graphCalendarService.deleteEvent(item.microsoft_graph_event_id);
                    }
                }
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadSetting() {
                const info = (await diaryService.getSetting())[0];

                vm.model.setting = info;
                vm.model.setting.breakpoint = responsive.current;
                vm.model.setting.functions = setupSchedulerFunctions();
            }

            async function loadPortalUsers() {
                vm.model.selectListPortalUsers = await diaryService.listPortalUsers();
            }

            async function loadTasks() {
                if (timerTask) clearTimeout(timerTask);

                timerTask = setTimeout(() => {
                    if (utilityService.validateParmsValue(vm.model.setting.date_fom) !== true) return;
                    if (utilityService.validateParmsValue(vm.model.setting.portal_user_keyno) !== true) return;
                    if (utilityService.validateParmsValue(vm.model.setting.selectedview, true) !== true) return;
                    
                    vm.model.taskList.records = [];

                    return diaryService.listTasks(vm.model.setting).then((list) => {
                        angular.copy(list, vm.model.taskList.records);
                    });
                }, 50);
            }

            async function loadOwners() {
                if (timerOwner) clearTimeout(timerOwner);

                timerOwner = setTimeout(() => {
                    if (utilityService.validateParmsValue(vm.model.setting.date_fom) !== true) return;
                    if (utilityService.validateParmsValue(vm.model.setting.portal_user_keyno) !== true) return;
                    if (utilityService.validateParmsValue(vm.model.setting.selectedview, true) !== true) return;

                    vm.model.ownerList.records = [];

                    return diaryService.listOwners(vm.model.setting).then((list) => {
                        angular.copy(list, vm.model.ownerList.records);
                    });
                }, 50);
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            function rememberFunc(id) {
                Object.keys(variableNames).forEach((key) => {
                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                });

                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                let variableValue = null;

                switch (id) {
                    case 'portal_user_keyno':
                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

                        variableValue = vm.model.setting[id];
                        break;
                    default:
                        break;
                }

                return rememberService.remember(variableNames[id], variableValue);
            }

            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            // #region SETUP SCHEDULER FUNCTIONS

            async function setupSchedulerFunctions() {
                return [
                    { name: 'add', func: function (data) { schedulerChange(this.name, data); } },
                    { name: 'update', func: function (data) { schedulerChange(this.name, data); } },
                    { name: 'delete', func: function (data) { schedulerChange(this.name, data); } },
                    { name: 'newDate', func: function (data) { schedulerChange(this.name, data); } }
                ];
            }

            async function schedulerChange(state, data) {
                switch (state) {
                    case 'add':
                        console.log('Item added to diary...');
                        break;
                    case 'update':
                        diaryService.updateItem(data).then(function (_response) {
                            addToMicrosoft365(data, true).then(function () {
                                console.log('Micro365 Updated')
                            });
                        });
                        break;
                    case 'delete':
                        console.log('Item not added...? Deleted...?');
                        break;
                    case 'newDate':
                        console.log('Item new date...');
                        break;
                    default:
                        console.log('Item default action...');
                        break;
                }
            }

            // #endregion SETUP SCHEDULER FUNCTIONS

            // #region MICROSOFT 365 FUNCTION

            function addToMicrosoft365(data, update) {
                if (!data?.id || data.id === 0) return $q.resolve();
                if (data.sync_with_microsoft_365 !== '1') return $q.resolve();

                const deferred = $q.defer();

                graphAuthService.getAccount().then(function (account) {
                    graphAuthService.getAccessToken(account).then(function (token) {
                        graphUserService.getUser(account.localAccountId, token).then(function (user) {
                            let dtStart = moment(data.start).format('YYYY-MM-DDTHH:mm:ss');
                            let dtEnd = moment(data.end).format('YYYY-MM-DDTHH:mm:ss');

                            if (update === true) {
                                const event = {
                                    start: {
                                        dateTime: dtStart, //'2023-08-24T15:15:00',
                                        timeZone: 'Europe/Berlin'
                                    },
                                    end: {
                                        dateTime: dtEnd, //'2023-08-24T15:20:00',
                                        timeZone: 'Europe/Berlin'
                                    }
                                };

                                graphCalendarService.updateEvent(event, { eventId: data.microsoft_graph_event_id }, token).then(function () {
                                    deferred.resolve();
                                });
                            }
                        });
                    });
                }).catch((reason) => {
                    console.log('ERROR');
                    console.dir(reason);
                    deferred.resolve();
                });

                return deferred.promise;
            }

            // #endregion MICROSOFT 365 FUNCTION

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'portal_user_keyno':
                        if (utilityService.validateWatchValue(value, vm.model.setting.portal_user_keyno) !== true) return;

                        vm.model.setting.portal_user_keyno = value;

                        if (utilityService.validateParmsValue(vm.model.setting.portal_user_keyno) !== true) return;

                        rememberFunc('portal_user_keyno');
                        loadTasks();
                        loadOwners();
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region WATCH FUNCTIONS

            watcher.$watch(function () {
                return vm.model.setting;
            }, function (newValue, oldValue) {
                if (newValue !== oldValue && vm.model?.setting) {
                    loadTasks();
                    loadOwners();
                }
            }, true);

            // #endregion WATCH FUNCTIONS

            // #region ANGULAR LIFECYCLE FUNCTION

            vm.$onInit = function () {
                loadSetting();
                loadPortalUsers();
            };

            // #endregion ANGULAR LIFECYCLE FUNCTION

        }]
    });
})();
